'use client';
import Sidebar from '@/components/Sidebar';
import ChiTietBaiViet from './components/ChiTietBaiViet';

export default function ChiTietBaiVietPage(props) {
  const { rightBanners, linkPages, websiteCode } = props;

  return (
    <div className="flex flex-col min-h-screen">
      <div className="container mx-auto flex-grow bg-white px-2 md:px-4 pt-2">
        <div className="flex flex-col lg:flex-row gap-6">
          <section className="lg:w-3/4">
            <ChiTietBaiViet {...props} />
          </section>
          <section className="w-full lg:w-1/4">
            <Sidebar rightBanners={rightBanners} linkPages={linkPages} websiteCode={websiteCode} />
          </section>
        </div>
      </div>
    </div>
  );
}
